import axios, { AxiosPromise } from 'axios';
import { IAppConfigResponse } from 'store/app/app.state';


const serviceUrls : { [key:string]:string} = {
    dev: "https://dev-services.smartagent.app",
    uat: "https://uat-services.smartagent.app",
    beta: "https://beta-services.smartagent.app",
    prod: "https://services.smartagent.app"   
}

const env = process.env.REACT_APP_ENV ?? 'dev';

const baseURL = serviceUrls[env];

interface IMakeRequest {
    url: string;
    data?: any;
    headers?: any;
    method?: 'get' | 'put' | 'post' | 'delete' | 'patch';
}
export function makeRequest<T = any>({ url, method = 'get', data, headers }: IMakeRequest) {
    return axios({
        baseURL,
        url,
        method,
        data,
        headers,
    }) as AxiosPromise<T>;
}


export const getAppConfig = async (company: string, facia: string, chatFlowId: string) => {
    const response = makeRequest<IAppConfigResponse>({
        url: `/chat-service/companies/${company}/facia/${facia ?? company}/chatconfig/?chatFlowId=${chatFlowId}`
    });

    return response;
};

export const getAttachmentUploadURL = async (company: string, facia: string, filename: string) => {
    const response = makeRequest<{ uploadURL: string, fileURL: string }>({
        url: `/chat-service/companies/${company}/facia/${facia ?? company}/attachments/${filename}/upload/`,
        method: "get",
    });

    return response;
}

export const getAttachmentUrl = async (company: string, facia: string, filename: string) => {
    const response = makeRequest<{  objectUrl: string }>({
        url: `/chat-service/companies/${company}/facia/${facia ?? company}/attachments/${filename}/`,
        method: 'get'
    });

    return response;
}

export const setUploadFileAttribute = async (company: string, instanceID:string, contactID: string, data: { [key: string]: string }) => {
    const response = makeRequest<{"attributes": any}>({
        url: `/contact-service/companies/${company}/instances/${instanceID}/contacts/${contactID}/attributes/unauthorized`,
        method: "post",
        data
    });

    return response;
}

type AttachmentSenderType = 'agent' | 'customer';

export const getChatAttachmentUrl = async (
    company: string,
    facia: string,
    key: string,
    senderType: AttachmentSenderType
) => {
    const response = makeRequest<{ objectUrl: string }>({
        url: `/chat-service/companies/${company}/facia/${
            facia ?? company
        }/chat-attachments/${senderType}?key=${key}`,
        method: 'get',
    });

    return response;
};
